import registerApiServices from "@/api/registerApiServices";
import api from "@godweb/frontend-base/src/libs/api/Api";
import AuthService from "@godweb/frontend-base/src/libs/auth/AuthService";
import loadKit from "@godweb/promos-base/src/config/loadKit";
import { OneLinkEventSender } from "@godweb/promos-base/src/js/one-link/one-link-event-sender";
import service_config from "@godweb/frontend-base/src/libs/auth/auth_service_config/projects/wrf/AuthServiceConfig";
import i18n from "@godweb/promos-base/src/js/localization/Localization";
import Vue from "vue";
import Vuex from "vuex";
import App from "./App";
import store from "./store/index";
import Icon from "@app_components/components/icon/vue/Icon.vue";
import EventBroker from "@godweb/frontend-base/src/libs/event-broker/EventBroker";
import ep from "@godweb/frontend-base/src/libs/auth/EpConst";

Vue.use(Vuex);

loadKit();

Vue.config.productionTip = false;
Vue.prototype.$api = window.api = api;
Vue.prototype.$authService = window.authService = AuthService;
Vue.prototype.$eventBroker = window.eventBroker = new EventBroker();
Vue.prototype.$oneLinkEventSender = window.oneLinkEventSender = new OneLinkEventSender({
  baseUrl: "https://warrobotsfrontiers.com/1l/",
  oneLinkId: process.env.VUE_APP_1LINK,
});

registerApiServices();
service_config.setDynamicParams({
  store,
  api,
});
service_config.setSocialEpList([ep.EP_GOOGLE, ep.EP_FB, ep.EP_TWITTER, ep.EP_TWITCH]);

AuthService.setConfig(service_config);

Vue.component("Icon", Icon);

new Vue({
  components: { App },
  mounted() {
    const INIT_VUE_COMPONENTS = new Event("init_vue_components");
    document.dispatchEvent(INIT_VUE_COMPONENTS);
  },
  render: h => h(App),
  i18n,
  store,
}).$mount("#app");
